import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Container, Dimmer, Grid, Header, Icon, Loader, Segment,Form,Button} from 'semantic-ui-react'
import {load as loadClock, save} from '../../reducer/actions';
import {getLoadedClock, isLoading} from '../../reducer';
import WarehouseSelect from '../../components/WarehouseSelect';
import ActivitySelect from '../../components/ActivitySelect';
import { Translate } from 'react-localize-redux';
import { push } from "react-router-redux";

// Components
import 'react-dates/lib/css/_datepicker.css';

// Css


class ClockEdit extends Component {

    constructor(props) {
        super(props);

        this.state = {
            warehouse_id: null,
            activity_id: null,
            start: '',
            end: '',
            loaded: false
        }

    }

    componentWillMount() {

        this.props.loadClock(this.props.match.params.id).then(()=>{
            this.setState({
                warehouse_id: this.props.clock === null ? null : this.props.clock.warehouse_id,
                activity_id: this.props.clock === null ? null : this.props.clock.activity_id,
                start: this.props.clock === null ? '' : this.props.clock.start.replace(' ', 'T'),
                end: this.props.clock === null ? '' : this.props.clock.end.replace(' ', 'T'),
                loaded: true,
            });

        });

    }

    saveClock(deleteClock = false){

        // Don't save when clock is not loaded

        if(this.state.loaded === false){
            return false;
        }

        let clock = JSON.parse(JSON.stringify({...this.state}));

        if(deleteClock){
            clock.delete = true;
        }

        this.props.save(this.props.match.params.id,clock);

    }


    render() {
        return (
            <Container style={{padding: '3em 1em'}}>
                <Dimmer active={this.props.isLoading}>
                    <Loader/>
                </Dimmer>
                <Header as='h2' icon textAlign='center'>
                    <Icon name='clock' circular/>
                </Header>
                <Grid
                    textAlign='center'
                    style={{height: '100%'}}
                    verticalAlign='middle'
                >
                    <Grid.Column width={16}>
                        <div>
                            <Header as='h2' color='teal' textAlign='center'>
                                <Translate id="edit" />
                            </Header>
                            <Segment stacked>




                                <Form size='large' loading={this.props.isLoading} onSubmit={()=>{this.saveClock()}}>
                                    <Segment stacked>
                                        <Form.Field required>
                                            <label>Start</label>
                                            <input type="datetime-local"  value={this.state.start}
                                                   step="1"
                                                   onChange={(e)=>{this.setState({start: e.target.value})}}
                                            />
                                        </Form.Field>
                                        <Form.Field required>
                                            <label>End</label>
                                            <input type="datetime-local"  value={this.state.end}
                                                   step="1"
                                                   onChange={(e)=>{this.setState({end: e.target.value})}}
                                            />
                                        </Form.Field>
                                        <ActivitySelect
                                            value={this.state.activity_id}
                                            onChange={(value) => this.setState({activity_id: value})}
                                        />
                                        <WarehouseSelect
                                            value={this.state.warehouse_id}
                                            onChange={(value) => this.setState({warehouse_id: value})}
                                        />

                                        <Button positive type='submit'>Save</Button>
                                        <Button negative type='button' onClick={()=>{
                                            this.saveClock(true);
                                            this.props.back();
                                        }}>Delete</Button>
                                    </Segment>
                                </Form>

                            </Segment>
                        </div>
                    </Grid.Column>
                </Grid>
            </Container>
        );
    }

}


const mapStateToProps = state => ({
    isLoading: isLoading(state),
    clock: getLoadedClock(state),

});


function mergeProps(stateProps, dispatchProps, ownProps) {

    return {
        ...dispatchProps,
        ...stateProps,
        ...ownProps
    }
}

const mapDispatchToProps = (dispatch) => {
    return ({
        loadClock: (id) => { return dispatch(loadClock(id))},
        save: (id,clock) => { return dispatch(save(id,clock))},
        back: (id)=>{dispatch(push('/clock/admin/reports'))}
    })
};


// No need to connect()!
export default connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(ClockEdit)



// WEBPACK FOOTER //
// ./src/scenes/Clock/scenes/ClockEdit/index.js